export function saveFile(blobData: string, filename: string) {
    const data = new Blob([blobData]);
    const URL = window.URL.createObjectURL(data);
    const tempLink = document.createElement('a');
    tempLink.href = URL;
    tempLink.setAttribute('download', filename);
    tempLink.click();
}

/**
 * Variante di saveFile per i download di grandi dimensioni (export massivi da centinaia di MB).
 * A differenza di saveFile non ri-avvolge il Blob in un secondo Blob - cosa che ne duplicherebbe
 * integralmente il contenuto - e revoca l'object URL a download avviato.
 */
export function saveLargeFile(blob: Blob, filename: string) {
    const objectUrl = window.URL.createObjectURL(blob);
    const tempLink = document.createElement('a');
    tempLink.href = objectUrl;
    tempLink.setAttribute('download', filename);
    tempLink.click();
    // Il download parte in modo sincrono al click, ma revocare subito puo' anticiparlo:
    // rimandare di un secondo libera comunque la memoria senza rischiare di annullarlo.
    setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
}

export function parseFilenameFromHeader(contentDisposition: string) {
    return contentDisposition.replace("attachment; filename=", "");
}